import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { getBrowserName, isLoggedIn } from "config/utils";
import Cookies from "js-cookie";

export const getBlogsList = async (data) => {
  try {
    const payload = {
      ...data,
      platformType: getBrowserName(),
    };

    // ✅ Pass payload as query params (NOT body)
    const response = await axios.get("/blogs-list", {
      params: payload,
    });

    return response.data;
  } catch (err) {
    console.error("blogs API Error:", err);
    throw err;
  }
};

export const getFeaturedBlogsList = async (data) => {
  try {
    const payload = {
      ...data,
      platformType: getBrowserName(),
    };

    // ✅ Pass payload as query params (NOT body)
    const response = await axios.get("/featured-blogs-list", {
      params: payload,
    });

    return response.data;
  } catch (err) {
    console.error("getFeaturedBlogsList API Error:", err);
    throw err;
  }
};

export const getBlogDetailById = async (data) => {
  try {
    if (!data?.id) throw new Error("Blog ID missing for getBlogDetailById");

    const payload = {
      ...data,
      platformType: getBrowserName(),
    };

    const response = await axios.get("/blog-details", { params: payload });
    return response.data;
  } catch (err) {
    console.error("getBlogDetailById API Error:", err);
    throw err;
  }
};


